<template>
  <div class="homepage">
    <b-container fluid class="pt-0">
      <b-row style="margin-bottom:5rem">
        <b-col cols="12">
          <Navbar />
        </b-col>
      </b-row>
      <div class="main_content">
        <router-view />
      </div>
      <b-row>
        <b-col>
          <Footer />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default {
  components: {
    Footer,
    Navbar
  }
};
</script>

<style lang="sass">
.h-50p
  height: 50px
.color-footer-item
  color: #fff !important
  margin-left: 3rem !important
.homepage
  overflow: hidden
.bg-color-footer-item
  background-color: white !important
.btn-tel
  background-color: #392d9e
  border: 2px solid white
.main_content
    min-height: 54.3vh
.homepage
    overflow: hidden
</style>
